module.exports = __webpack_public_path__ + "static/media/apr2025_steel.520ecf7f.webp";